import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import {DateAdapter, MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ListingComponent } from './components/listing/listing.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { AppRoutingModule } from 'app/app-routing.module';
import { FsUrlPartCutPipe } from './pipes/fs-url-part-cut.pipe';
import { FsGetUrlPartByIdxPipe } from './pipes/fs-get-url-part-by-idx.pipe';
import { MkdirDialogComponent } from './components/mkdir-dialog/mkdir-dialog.component';
import { DirectLinkDialogComponent } from './components/direct-link-dialog/direct-link-dialog.component';
import { FocusOutDirective } from './directives/focus-out.directive';
import { ScrollDirective } from './directives/scroll.directive';
import { ZipDialogComponent } from './components/zip-dialog/zip-dialog.component';
// import { NgScrollbarModule } from 'ngx-scrollbar';
import { ProfilePasswordResetComponent } from './components/profile-password-reset/profile-password-reset.component';
import { HttpClientModule } from '@angular/common/http';
import { MfaFormComponent } from './components/mfa-form/mfa-form.component';
import { RenameDialogComponent } from './components/rename-dialog/rename-dialog.component';
import { FsDatePipe } from './pipes/fs-date.pipe';
import { FsFileSizePipe } from './pipes/fs-file-size.pipe';
import { BottomToolbarComponent } from './components/bottom-toolbar/bottom-toolbar.component';
import { SortButtonComponent } from './components/sort-button/sort-button.component';
import { NotificationComponent } from './components/notification-component/notification-container.component';
import { UploaderDialogComponent } from './components/uploader-dialog/uploader-dialog.component';
import { UploadButtonComponent } from './components/upload-button/upload-button.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FS3Interceptor } from './http-interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { FolderDoesnotExistComponent } from './components/folder-doesnot-exist/folder-doesnot-exist.component';
import { ListingItemComponent } from './components/listing-item/listing-item.component';
import { DeleteConfirmationComponent } from './components/delete-confirmation/delete-confirmation.component';
import { FsMessageTransformPipe } from './pipes/fs-message-transform.pipe';
import { ProfilePasswordChangeComponent } from './components/profile-password-change/profile-password-change.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { DialogCanvasComponent } from './components/dialog-canvas/dialog-canvas.component';
import { ClientClassesPipe } from './pipes/client-classes.pipe';
import { PointsFormComponent } from './components/points-form/points-form.component';
import { LeftMenuComponent } from './components/left-menu/left-menu.component';
import { TileListingItemComponent } from './components/tile-listing-item/tile-listing-item.component';
import { ArticleViewComponent } from './components/article-view/article-view.component';
import { ArticleViewContainerComponent } from './components/article-view-container/article-view-container.component';
import {DragDropModule} from "@angular/cdk/drag-drop";
import { ArticlesReorderComponent } from './components/articles-reorder/articles-reorder.component';
import { RenameFormComponent } from './components/rename-form/rename-form.component';
import { ExportArticleComponent } from './components/popups/export-article/export-article.component';
import { HtmlHelperPipe } from './pipes/html-helper.pipe';
import { SharePickerComponent } from './components/popups/share-picker/share-picker.component';
import { ArticleItemEditorComponent } from './components/popups/article-item-editor/article-item-editor.component';
import { QuickUploaderComponent } from './components/quick-uploader/quick-uploader.component';
import { CourseEditorComponent } from './components/popups/course-editor/course-editor.component';
import { MobileContainerComponent } from './components/mobile/mobile-container/mobile-container.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MobileAvatarComponent } from './components/mobile/mobile-avatar/mobile-avatar.component';
import { MobileMetricsComponent } from './components/mobile/mobile-metrics/mobile-metrics.component';
import { LiqPayWidgetComponent } from './components/mobile/liq-pay-widget/liq-pay-widget.component';
import { TopMenuComponent } from './components/mobile/top-menu/top-menu.component';
import { GroupEventsListComponent } from './components/mobile/group-events-list/group-events-list.component';
import { EventListingItemComponent } from './components/mobile/event-listing-item/event-listing-item.component';
import { EventItemViewComponent } from './components/mobile/event-item-view/event-item-view.component';
import { UserDetailsComponentComponent } from './components/mobile/user-details-component/user-details-component.component';
import { GetLabelPipe } from './pipes/get-label.pipe';
import { ClassDetailsComponent } from './components/mobile/class-details/class-details.component';
import { SubscribeEventFormComponent } from './components/mobile/subscribe-event-form/subscribe-event-form.component';
import { TrustPipe } from './pipes/trust.pipe';
import { GroupCreateFormComponent } from './components/mobile/group-create-form/group-create-form.component';
import { RelationButtonComponent } from './components/listing/relation-button/relation-button.component';
import { RelationConfirmationComponent } from './components/listing/relation-confirmation/relation-confirmation.component';
import { FriendInvitationComponent } from './components/popups/friend-invitation/friend-invitation.component';
import { GameProposalComponentComponent } from './components/popups/game-proposal-component/game-proposal-component.component';
import { CalendarContainerComponent } from './components/mobile/calendar-container/calendar-container.component';
import {FullCalendarModule} from "@fullcalendar/angular";
import { AppComponent } from './app.component';
import { BootstrapComponent } from './bootstrap/bootstrap.component';
import { SimpleListComponent } from './components/mobile/simple-list/simple-list.component';
import { TrainerDetailsComponent } from './components/mobile/trainer-details/trainer-details.component';
import { ScheduleCalendarEventFormComponent } from './components/mobile/schedule-calendar-event-form/schedule-calendar-event-form.component';
import {CustomDateAdapter} from "./utils/custom-date-adapter";
import { DeleteSchedulePopupComponent } from './components/popups/delete-schedule-popup/delete-schedule-popup.component';
import { ProfileEditComponentComponent } from './components/mobile/profile-edit-component/profile-edit-component.component';
import { PhoneFormatterPipe } from './pipes/phone-formatter.pipe';
import { ProfileInfoPopupComponent } from './components/popups/profile-info-popup/profile-info-popup.component';
import { ShareLinkPopupComponent } from './components/popups/share-link-popup/share-link-popup.component';
import { PlayConfigFormComponent } from './components/popups/play-config-form/play-config-form.component';
import { UserDetailsPopupComponent } from './components/popups/user-details-popup/user-details-popup.component';
import { PlayConfigLabelPipe } from './pipes/play-config-label.pipe';
import { TrainerSetupPopupComponent } from './components/popups/trainer-setup-popup/trainer-setup-popup.component';
import { TrainersWidgetComponent } from './components/trainers-widget/trainers-widget.component';
import { TrainerItemComponent } from './components/mobile/simple-list/renderers/trainer-item/trainer-item.component';
import { TrainerInfoPopupComponent } from './components/popups/trainer-info-popup/trainer-info-popup.component';
import { UserPickerComponent } from './components/popups/user-picker/user-picker.component';
import { UserReferralsPopupComponent } from './components/popups/user-referrals-popup/user-referrals-popup.component';
import { UserPurchasesPopupComponent } from './components/popups/user-purchases-popup/user-purchases-popup.component';
import { ServicePickerPopupComponent } from './components/popups/service-picker-popup/service-picker-popup.component';
import { TrainerCalendarEventFormComponent } from './components/mobile/trainer-calendar-event-form/trainer-calendar-event-form.component';
import { CupPlayerItemComponent } from './components/mobile/simple-list/renderers/cup-player-item/cup-player-item.component';
import { CupPlayerInfoPopupComponent } from './components/popups/cup-player-info-popup/cup-player-info-popup.component';
import { CupGamePopupComponent } from './components/popups/cup-game-popup/cup-game-popup.component';
import { SendMessagePopupComponent } from './components/popups/send-message-popup/send-message-popup.component';
import { UserDraggerPopupComponent } from './components/popups/user-dragger-popup/user-dragger-popup.component';
import { ServiceConfigPopupComponent } from './components/popups/service-config-popup/service-config-popup.component';
import { PackageConfigPopupComponent } from './components/popups/package-config-popup/package-config-popup.component';
import { BigCalendarContainerComponent } from './components/big-calendar-container/big-calendar-container.component';
import { BasicCalendarEventFormComponent } from './components/basic-calendar-event-form/basic-calendar-event-form.component';

@NgModule({
  declarations: [
    AppComponent,
    ListingComponent,
    LoginFormComponent,
    FsUrlPartCutPipe,
    FsGetUrlPartByIdxPipe,
    MkdirDialogComponent,
    DirectLinkDialogComponent,
    FocusOutDirective,
    ScrollDirective,
    ZipDialogComponent,
    ProfilePasswordResetComponent,
    MfaFormComponent,
    RenameDialogComponent,
    FsDatePipe,
    FsFileSizePipe,
    BottomToolbarComponent,
    SortButtonComponent,
    UploaderDialogComponent,
    NotificationComponent,
    UploadButtonComponent,
    NotFoundPageComponent,
    ConfirmationDialogComponent,
    NotFoundPageComponent,
    FolderDoesnotExistComponent,
    ListingItemComponent,
    DeleteConfirmationComponent,
    BootstrapComponent,
    FsMessageTransformPipe,
    ProfilePasswordChangeComponent,
    UserMenuComponent,
    DialogCanvasComponent,
    ClientClassesPipe,
    PointsFormComponent,
    LeftMenuComponent,
    TileListingItemComponent,
    ArticleViewComponent,
    ArticleViewContainerComponent,
    ArticlesReorderComponent,
    RenameFormComponent,
    ExportArticleComponent,
    HtmlHelperPipe,
    SharePickerComponent,
    ArticleItemEditorComponent,
    QuickUploaderComponent,
    CourseEditorComponent,
    MobileContainerComponent,
    MobileAvatarComponent,
    MobileMetricsComponent,
    LiqPayWidgetComponent,
    TopMenuComponent,
    GroupEventsListComponent,
    EventListingItemComponent,
    EventItemViewComponent,
    UserDetailsComponentComponent,
    GetLabelPipe,
    ClassDetailsComponent,
    SubscribeEventFormComponent,
    TrustPipe,
    GroupCreateFormComponent,
    RelationButtonComponent,
    RelationConfirmationComponent,
    FriendInvitationComponent,
    GameProposalComponentComponent,
    CalendarContainerComponent,
    SimpleListComponent,
    TrainerDetailsComponent,
    ScheduleCalendarEventFormComponent,
    DeleteSchedulePopupComponent,
    ProfileEditComponentComponent,
    PhoneFormatterPipe,
    ProfileInfoPopupComponent,
    ShareLinkPopupComponent,
    PlayConfigFormComponent,
    UserDetailsPopupComponent,
    PlayConfigLabelPipe,
    TrainerSetupPopupComponent,
    TrainersWidgetComponent,
    TrainerItemComponent,
    TrainerInfoPopupComponent,
    UserPickerComponent,
    UserReferralsPopupComponent,
    UserPurchasesPopupComponent,
    ServicePickerPopupComponent,
    TrainerCalendarEventFormComponent,
    CupPlayerItemComponent,
    CupPlayerInfoPopupComponent,
    CupGamePopupComponent,
    SendMessagePopupComponent,
    UserDraggerPopupComponent,
    ServiceConfigPopupComponent,
    PackageConfigPopupComponent,
    BigCalendarContainerComponent,
    BasicCalendarEventFormComponent,
  ],
  entryComponents: [
    MkdirDialogComponent,
    RenameDialogComponent,
    DirectLinkDialogComponent,
    ZipDialogComponent,
    UploaderDialogComponent,
    ConfirmationDialogComponent,
    DeleteConfirmationComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    // ,MaterialModule
    // NgScrollbarModule,
    FlexLayoutModule,
    ScrollingModule,
    DragDropModule,
    LayoutModule,
    FullCalendarModule,
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: FS3Interceptor,
    multi: true
    },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: AppComponent },
    { provide: MobileContainerComponent },
  ],
  bootstrap: [BootstrapComponent]
})
export class AppModule {
  constructor() {
  }
}
